import { useRouter } from 'next/router'
import htmlParser from 'html-react-parser'
import { ReactElement } from 'react'

const webpageTypes = {
  others: 0,
  checkout: 1,
  thankyou: 2
}

const appendTypes = {
  head: 0,
  body: 1
}

export type UseTracker = {
  customScript: (scripts) => void
}

const matchCurrentPageType = (webpageType, router) => {
  let current
  switch (router.pathname) {
    case '/[locale]/checkout/[storeOrderId]':
      current = 'checkout'
      break
    case '/[locale]/thankyou':
      current = 'thankyou'
      break
    default:
      break
  }
  // Temporary disable all external scripts for loyalty page before have solid product direction.
  if (current === 'loyalty') return false
  return (
    webpageType === webpageTypes[current] ||
    (!webpageTypes[current] && webpageType === webpageTypes.others)
  )
}

const useCustomScripts = (): UseTracker => {
  const router = useRouter()

  const customScript = (scripts) => {
    const existScript = document.body
      ?.querySelectorAll('.oddle-tracker')
    if (Array.isArray(existScript)) {
      existScript.forEach((el) => el.remove())
    }
    scripts?.data
      ?.filter(
        (script) =>
          matchCurrentPageType(script.webpageType, router) &&
          script.appendType === appendTypes.body &&
          script.trackerScript
      )
      ?.map((script) => {
        const parsedHtml = htmlParser(script.trackerScript) as ReactElement
        if (!parsedHtml.props) return
        const s = document.createElement('script')
        s.className = 'oddle-tracker'
        s.async = true
        if (parsedHtml.props.dangerouslySetInnerHTML) {
          s.type = 'text/javascript'
          s.innerHTML = parsedHtml.props.dangerouslySetInnerHTML.__html
        } else {
          s.type = 'script'
          s.src = parsedHtml.props.src
        }
        document.body.appendChild(s)
      })
  }

  return {
    customScript
  }
}

export default useCustomScripts
